import { mapGetters, mapActions } from 'vuex'
import user from '@/api/user'
import help from '@/utils/help'
export default {
  data() {
    return {
      form: {
        key: '',
        password: ''
      },
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId'
    })
  },
  mounted() {
    this.form.key = this.$route.query.key
    this.getRules()
    this.getInfo()
    document.onkeyup = e => {
      // 兼容FF和IE和Opera
      var event = e || window.event
      var key = event.which || event.keyCode || event.charCode
      if (key == 13 && this.$route.path === '/access/login') {
        this.submit()
      }
    }
  },
  methods: {
    ...mapActions(['updateLanguage', 'updateUser', 'updateToken']),
    async submit() {
      const flag = this.$refs['login-form'].validate()
      if (flag) {
        if (this.form.password !== this.form.repassword) {
          this.$message.error({
            title: 'Error',
            content: 'The two passwords are inconsistent, please re-enter!'
          })
          return
        }
        const data = Object.assign(this.form)
        const { token, refreshToken, expire } = await user.reset(data)

        localStorage.setItem('token', 'Bearer ' + token)
        this.updateToken('Bearer ' + token)
        localStorage.setItem('refreshToken', refreshToken)
        localStorage.setItem('expire', expire)

        this.$message.success({
          title: 'Success',
          content: 'Password reset complete'
        })
        this.getInfo()
      }
    },
    async getInfo() {
      if (!localStorage.getItem('token')) {
        return
      }
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateUser(res)
      if (
        help.arrIncludes(this.user.roles, [
          'OTHER',
          'PUBLISHER_ADMIN',
          'MANAGER_EDITOR',
          'WEBSITE_EDITOR'
        ])
      ) {
        this.$router.push('/home')
      } else if (
        help.arrIncludes(this.user.roles, [
          'AUTHOR',
          'EDITORIAL_BOARD',
          'GUEST_EDITOR'
        ])
      ) {
        this.$router.push('/author/submitted-manuscripts')
      } else if (help.arrIncludes(this.user.roles, ['REVIEWER'])) {
        this.$router.push('/reviewers-menu/reviews')
      } else {
        this.$router.push('/user-manage/profile')
      }
    },
    getRules() {
      const that = this
      this.rules = {
        password: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            min: 6,
            message: `Password should be more than 6 characters.`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 characters`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols, but not spaces.`
          }
        ],
        repassword: [
          {
            required: true,
            message:
              'Confirm Password' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            min: 6,
            message: `Password should be more than 6 characters.`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 characters`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols, but not spaces.`
          },
          {
            fun() {
              return that.form.password === that.form.repassword
            },
            message: `Confirm Password should be the same as above password.`
          }
        ]
      }
    }
  }
}
